import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { BaseVisualizacaoSubCadastro, BaseVisualizacaoSubCadastroService, DataTablesService } from '../../../core';

import { CidadeSubRegiao } from './cidade-sub-regiao';
import { CidadeSubRegiaoFormComponent } from './form';

@Component({
    selector: 'sgt-cidade-sub-regiao',
    templateUrl: './cidade-sub-regiao.component.html',
    styleUrls: ['./cidade-sub-regiao.component.less']
})
export class CidadeSubRegiaoComponent implements BaseVisualizacaoSubCadastro<CidadeSubRegiao>, OnInit {
    dataTable: any;
    isFormOpen: boolean;

    @Input() entities: CidadeSubRegiao[];
    @ViewChild('form') form: CidadeSubRegiaoFormComponent;

    constructor(private baseVisualizacaoSubCadastroService: BaseVisualizacaoSubCadastroService,
                private dataTablesService: DataTablesService) { }

    ngOnInit() {
        this.showTable();
    }

    openForm() {
        this.baseVisualizacaoSubCadastroService.openForm(this);
    }

    closeForm() {
        this.baseVisualizacaoSubCadastroService.closeForm(this);
    }

    showTable() {
        this.dataTablesService.showTable('#tableSubRegioes', this.dataTable)
            .then(dataTable => this.dataTable = dataTable);
    }

    insert() {
        this.baseVisualizacaoSubCadastroService.insert(this);
    }

    edit(index: number) {
        this.baseVisualizacaoSubCadastroService.edit(this, index);
    }

    delete(index: number) {
        this.baseVisualizacaoSubCadastroService.delete(this, index, this.entities, 'Deseja realmente excluir essa sub-região?')
            .then(() => {})
            .catch(() => {});
    }

    onFormSave(entity: CidadeSubRegiao) {
        this.closeForm();
    }

    onFormCancel() {
        this.closeForm();
    }
}
